import React from "react";

import AuthenticationContext from "../contexts/AuthenticationContext";

const useAuthentication = () => React.useContext(AuthenticationContext);

export default useAuthentication;
